let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("373qZ")).then(() => parcelRequire('fObJH'));